<template lang="pug">
  v-dialog(v-model="value" max-width="600px" persistent)
    v-card.rounded-card.registration-fee-card(
      data-cy="registration-fee-modal"
    )
      v-card-title
        v-layout(row wrap justify-center)
          v-flex(xs12)
            h1.primary--text.text-xs-center.font-weight-thin.title-pad.mt-2 Registration Fee
      v-card-text.pt-1
        v-layout(row justify-center wrap)
          v-flex(v-if="!isRetry && !isBrandRetry" xs12)
            v-flex(v-if="!isStandardRegistration" xs12)
              span Wireless carriers require a one-time $19 Registration fee and a $2 monthly fee which we will collect and process on your behalf.
            v-flex(v-else xs12)
              span Wireless carriers require a one-time $109 Registration fee and a $12 monthly fee which we will collect and process on your behalf.
            v-flex.pt-3(v-if="!hasBulkTextsAccess" xs12)
              span To safeguard your custom number's reputation with carriers, mass texting is not supported in LionDesk.
            v-flex.py-3(v-if="shouldShowChargebeeIframe" xs12)
              span Please enter your credit card information.
            v-flex.py-3(v-else xs12)
              span We'll use the credit card you have on file.
          v-flex(v-else-if="isRetry" xs12)
            v-flex(xs12)
              span Your previous text message type registration attempt was not accepted by the carriers. Mobile carriers charge a one-time $15 vetting fee for every re-submission attempt.
          v-flex(v-else-if="!isStandardRegistration" xs12)
            v-flex(xs12)
              span US mobile carriers charge a one-time fee for every 3 submission attempts.
              br 
              span We’ll use the credit card you have on file.
          v-flex(v-else xs12)
            v-flex(xs12)
              span US mobile carriers charge a one-time fee for every 2 submission attempts.
              br 
              span We’ll use the credit card you have on file.
          custom-error-registration(
            v-if="addRegisterFeeAddonsError" 
            xs12 
            :registrationStatus10dlc="registrationStatus10dlc"
            :registrationCampaignRetries="registrationCampaignRetries"
          ).mt-1
            template(slot="customError")
              div
                span There was an error with your payment submission. If error persists, please notify
                  a(:href="errorMailString" target='_blank') &nbsp;support@liondesk.com&nbsp;
                span that you had problems with your registration fee submission.&nbsp;
                span.wrap-content Error: {{addRegisterFeeAddonsError}}
          v-flex(v-if="shouldShowChargebeeIframe" xs12)
            v-layout(column align-center justify-center)
              v-flex.mt-5(v-if="hostedPageLoading" xs2)
                v-progress-circular(:size="80" :width="8" color="primary" indeterminate)
              v-flex(v-if="hostedPageLoading" xs12)
                h3.primary--text Loading the ccard payment form
              #ld-chargebee-wrapper
          v-flex(v-else-if="!isRetry && !isBrandRetry" xs12)
            v-layout.registration-fee-body(
              row
              wrap
              justify-space-between
            )
              v-flex(xs6 offset-xs1)
                h3 Registration Fee
              v-flex(v-if="!isStandardRegistration" xs2)
                h3 $19.00
              v-flex(v-else xs2)
                h3 $109.00
              v-flex(xs10 offset-xs1)
                span * Billed only once
              v-flex(xs6 offset-xs1)
                h3 Monthly Fee
              v-flex(v-if="!isStandardRegistration" xs2)
                h3 $2.00
              v-flex(v-else xs2)
                h3 $12.00
              v-flex(xs10 offset-xs1)
                span * Automatically billed each month
              v-flex(xs10 offset-xs1)
                hr
              v-flex(xs6 offset-xs1)
                h3 Total
              v-flex(v-if="!isStandardRegistration" xs2)
                h3 $21.00
              v-flex(v-else xs2)
                h3 $121.00
              v-flex(xs10 offset-xs1)
                span The registration and monthly fees are non-refundable.
          v-flex(v-else-if="isRetry" xs12)
            v-layout.pt-4.registration-fee-body(row wrap justify-space-between)
              v-flex(xs7 offset-xs1)
                h3 One-Time Message Type Re-submission Fee
              v-flex(xs2)
                h3 $15.00
              v-flex(xs10 offset-xs1)
                span * Billed only once
              v-flex.py-3(xs10 offset-xs1)
                hr
              v-flex(xs6 offset-xs1)
                h3 Total
              v-flex(xs2)
                h3 $15.00
              v-flex(xs10 offset-xs1)
                span The registration and monthly fees are non-refundable.
          v-flex(v-else xs12)
            v-layout.pt-4.registration-fee-body(row wrap justify-space-between)
              v-flex(xs7 offset-xs1)
                h3 Identity Registration Fee
              v-flex(v-if="!isStandardRegistration" xs2)
                h3 $4.00
              v-flex(v-else xs2)
                h3 $44.00
              v-flex(xs10 offset-xs1)
                span * Billed only once
              v-flex.py-3(xs10 offset-xs1)
                hr
              v-flex(xs6 offset-xs1)
                h3 Total
              v-flex(v-if="!isStandardRegistration" xs2)
                h3 $4.00
              v-flex(v-else xs2)
                h3 $44.00
              v-flex(xs10 offset-xs1)
                span The registration and monthly fees are non-refundable.
          v-layout.pt-4(row wrap justify-center)
            v-flex.text-xs-center(xs12)
              v-btn.primary(
                v-if="!isRegisterFeeAddonsLoading && (!shouldShowChargebeeIframe || isRetry || isBrandRetry)"
                @click="submitRegistrationFee"
              ) Submit Payment
              v-progress-circular(v-if="isRegisterFeeAddonsLoading" indeterminate color="primary")
            v-flex.text-xs-center(xs12)
              v-btn(flat color="primary" @click="$emit('close')") Cancel
</template>

<script>
/* global ChargeBee */
import { mapState, mapActions, mapGetters } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import { REGISTRATION_STATES } from '../../Text/config/registrationStatus';
import CustomErrorRegistration from './CustomErrorRegistration';
import { standard } from '../../Text/config/consoleSteps';
import { LdFeatures } from 'lion-vue';

export default {
  components: {
    TitleBar,
    CustomErrorRegistration,
  },
  name: 'RegisterFeeModal',
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      addRegisterFeeAddonsSuccess: state => state.payment.addRegisterFeeAddonsSuccess,
      addRegisterFeeAddonsError: state => state.payment.addRegisterFeeAddonsError,
      updatePaymentMethodHostedPageURL: state => state.payment.updatePaymentMethodHostedPageURL,
      registrationStatus10dlc: state => state.conversations.registrationStatus10dlc,
      registrationCampaignRetries: state => state.conversations.registrationCampaignRetries,
      isRegisterFeeAddonsLoading: state => state.payment.isRegisterFeeAddonsLoading,
      registrationType10dlc: state => state.conversations.registrationType10dlc,
      has10dlcRegister: state => state.conversations.has10dlcRegister,
      isRegistration10dlcIncomplete: state => state.conversations.isRegistration10dlcIncomplete,
      chargebeeCustomer: state => state.payment.chargebeeCustomer,
    }),
    ...mapGetters('payment', ['customerHasValidCC']),
    ...mapGetters('userInformation', ['hasAccessToFeature']),
    shouldShowChargebeeIframe() {
      return this.chargebeeCustomer && !this.customerHasValidCC && !this.ccAddedSuccessfully;
    },
    shouldSkipModal() {
      return ![REGISTRATION_STATES.PAYMENT_CAMPAIGN_RETRY_PENDING, REGISTRATION_STATES.PAYMENT_PENDING, REGISTRATION_STATES.PAYMENT_BRAND_RETRY_PENDING].includes(
        this.registrationStatus10dlc,
      );
    },
    isRetry() {
      return this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_CAMPAIGN_RETRY_PENDING;
    },
    isBrandRetry() {
      return this.registrationStatus10dlc === REGISTRATION_STATES.PAYMENT_BRAND_RETRY_PENDING;
    },
    errorMailString() {
      var subject = encodeURIComponent('Texting Identity Registration Error: Registration Fee');
      var body = encodeURIComponent(
        ''.concat('I am getting this error in the Registration Fee: ', this.addRegisterFeeAddonsError),
      );
      return ''.concat('mailto:support@liondesk.com?subject=', subject, '&body=', body);
    },
    isStandardRegistration() {
      return this.registrationType10dlc === standard;
    },
    hasBulkTextsAccess() {
      return this.hasAccessToFeature(LdFeatures.BulkTexts);
    },
  },
  async mounted() {
    if(!this.has10dlcRegister || this.isRegistration10dlcIncomplete) {
      await this.checkFor10dlcRegister();
    }
    if (this.shouldSkipModal) {
      this.$emit('skip');
    }
    await this.getChargebeeCustomer();
    if (this.shouldShowChargebeeIframe) {
      this.hostedPageLoading = true;
      await this.getUpdatePaymentHostedPage();
      let chargebeeENV = 'liondesk'
      if (process.env.NODE_ENV !== 'production') {
        chargebeeENV = 'liondesk-test'
      }
      ChargeBee.embed(this.updatePaymentMethodHostedPageURL, chargebeeENV).load({
        // Insert hosted page frame
        addIframe: iframe => {
          this.hostedPageLoading = false;
          const cbWrapper = document.getElementById('ld-chargebee-wrapper');
          if (cbWrapper) {
            cbWrapper.style.height = '500px`';
            cbWrapper.style.overflow = 'auto';
            cbWrapper.append(iframe);
            cbWrapper.firstElementChild.classList.add('chargebee-addcard-frame');
          }
        },
        onLoad: (iframe, width, height) => {
          iframe.style.visibility = 'unset !important';
        },
        onSuccess: iframe => {
          iframe.style.visibility = 'hidden !important';
          iframe.remove();
          this.ccAddedSuccessfully = true;
        },
        onCancel: iframe => {
          this.$emit('close');
        },
        onError: (iframe, error) => {
          if (
            error.errors[0].message === "'Your credit card has been already updated successfully.'"
          ) {
            iframe.style.visibility = 'hidden !important';
            iframe.remove();
            this.ccAddedSuccessfully = true;
          }
        },
      });
    }
  },
  data() {
    return {
      ccAddedSuccessfully: false,
      hostedPageError: null,
      hostedPageLoading: false,
    };
  },
  methods: {
    ...mapActions('payment', [
      'addRegisterFeeAddons',
      'getChargebeeCustomer',
      'getUpdatePaymentHostedPage',
    ]),
    ...mapActions('conversations', ['checkFor10dlcRegister']),
    submitRegistrationFee() {
      this.addRegisterFeeAddons({ isRetry: this.isRetry, isBrandRetry: this.isBrandRetry, isStandard: this.isStandardRegistration });
    },
  },
};
</script>

<style lang="scss">
.registration-fee-title {
  margin: auto;
  color: var(--v-primary-base);
  font-size: 25px;
}

.registration-fee-card {
  overflow: auto;
}

.registration-fee-body {
  height: 160px;
  width: 300;
}

#ld-chargebee-wrapper {
  position: relative;
  height: 500px;
  width: 100%;

  iframe {
    border: none;
  }
}

.chargebee-frame {
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  visibility: unset !important;

  html {
    overflow: hidden;
  }
}

.chargebee-addcard-frame {
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  height: 800px !important;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  visibility: unset !important;

  html {
    overflow: hidden;
  }
}

.wrap-content {
  overflow-wrap: anywhere;
}
</style>
